import React from "react";
import { useTranslation } from "react-i18next";
import {
    FaTwitter,
    FaFacebookF,
    FaWhatsapp,
    FaRedditAlien,
} from "react-icons/fa";

const ShareDialog = (props) => {
    const { open } = props;
    const { t } = useTranslation();

    return (
        <>


            {open && (
                <div className="share-dialog glass-box p-2">
                    <h6 className="text-white mb-4">{t("news.shareDialog.title")}</h6>
                    <div className="d-flex justify-content-around align-items-center  gap-3">
                        <div className="share-option">
                            <div className="circle_icon bgtwitter">
                                <FaTwitter className="icon twitter" />
                            </div>
                            <span>{t("news.shareDialog.linkedin")}</span>
                        </div>
                        <div className="share-option">
                            <div className="circle_icon bgfacebook">
                                <FaFacebookF className="icon facebook" />
                            </div>
                            <span>{t("news.shareDialog.mail")}</span>
                        </div>
                        <div className="share-option">
                            <div className="circle_icon bgtwhatsapp">
                                <FaWhatsapp className="icon whatsapp" />
                            </div>
                            <span>{t("news.shareDialog.whatsapp")}</span>
                        </div>
                        <div className="share-option">
                            <div className="circle_icon bgreddit">
                                <FaRedditAlien className="icon reddit" />
                            </div>
                            <span>{t("news.shareDialog.copy")}</span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ShareDialog;
